import React from 'react'
import { Link } from 'gatsby'

export default function Violator(){
    return(
        <Link
            id='violator'
            to='/sale'
            className='position-relative m-0 d-block text-center text-black bg-primary fw-bold'
            style={{ zIndex: 4, textWrapStyle: 'balance' }}
        >
            SPEND MORE, SAVE UP TO AN EXTRA 25% — SHOP THE SALE!
        </Link>
    )
}
